import React, { forwardRef } from "react";
import {
  StyledContentWrapper,
  StyledMediaContainer,
  StyledMessageContainer,
  StyledMessageErrorMsg,
  StyledMessageRow,
  StyledMessageTimeStamps,
} from "../../Styles/StyledComponents";
import { getMessageTime } from "../../utils/utils";
import AppChatUserAvatar from "./AppChatUserAvatar";
import { useSelector } from "react-redux";
import { botInfoStore } from "../../../Store/Slices/socket/BotInfoSlice";
interface Props {
  children: any;
  userMessage: boolean;
  isMedia?: boolean;
  isButton?: boolean;
  divStyle?: React.CSSProperties;
  rowStyle?: React.CSSProperties;
  time?: string;
  ref?: any;
  isError?: boolean;
  readStatus?: "sent" | "delivered" | "seen";
}

const AppMessageBoxWrapper = forwardRef<HTMLDivElement, Props>(
  (
    {
      userMessage = false,
      isMedia = false,
      isButton = false,
      divStyle,
      rowStyle,
      children,
      time = "",
      readStatus = "delivered",
      isError = false,
    },
    ref
  ) => {
    const { isBotSetToFullScreen } = useSelector(botInfoStore);
    if (isMedia) {
      return (
        <StyledMessageRow
          userMessage={userMessage}
          style={rowStyle}
          isButton={isButton}
          className={"styledMessageRow"}
        >
          <AppChatUserAvatar isButton={isButton} userMessage={userMessage} />
          <StyledContentWrapper userMessage={userMessage}>
            <StyledMediaContainer
              userMessage={userMessage}
              style={divStyle}
              isButton={isButton}
            >
              {children}
            </StyledMediaContainer>
            <StyledMessageTimeStamps
              userMessage={userMessage}
              isButton={isButton}
            >
              {getMessageTime(time)}
              {/* <AppChatReadReceipts
              userMessage={userMessage}
              status={readStatus}
            /> */}
            </StyledMessageTimeStamps>
          </StyledContentWrapper>
        </StyledMessageRow>
      );
    }

    return (
      <StyledMessageRow
        userMessage={userMessage}
        style={rowStyle}
        className={"styledMessageRow"}
        ref={ref}
      >
        <AppChatUserAvatar userMessage={userMessage} />
        <StyledContentWrapper userMessage={userMessage}>
          <StyledMessageContainer
            userMessage={userMessage}
            style={divStyle}
            isFullScreen={isBotSetToFullScreen}
          >
            {children}
          </StyledMessageContainer>
          {
            isError && userMessage && (
              <StyledMessageErrorMsg
                userMessage={userMessage}
              >
                Something went wrong
              </StyledMessageErrorMsg>
            )
          }
          <StyledMessageTimeStamps
            userMessage={userMessage}
            isButton={isButton}
          >
            {getMessageTime(time)}

            {/* <AppChatReadReceipts userMessage={userMessage} status={readStatus} /> */}
          </StyledMessageTimeStamps>
        </StyledContentWrapper>
      </StyledMessageRow>
    );
  }
);

export default AppMessageBoxWrapper;
